const FormMasterSettings = ({ form, onFormChange,shouldDisableFields }) => {debugger;
    // Fields for settings in the formMaster object
    const settings = [
      { label: "Allow reviewer to add attachment?", field: "allowReviewerToAddAttachment" },
      { label: "Allow reviewer to add comment?", field: "allowReviewerToAddComment" },
      { label: "Allow reviewer to print?", field: "allowReviewerToPrint" },
      { label: "Allow others to add attachment?", field: "allowOthersToAddAttachment" },
      { label: "Allow others to add comment?", field: "allowOthersToAddComment" },
      { label: "Allow others to print?", field: "allowOthersToPrint" },
      { label: "Allow submitter to add attachment?", field: "allowSubmitterToAddAttachment" },
      { label: "Allow submitter to add comment?", field: "allowSubmitterToAddComment" },
      { label: "Allow submitter to print?", field: "allowSubmitterToPrint" },
    ];
  
    return (
      <div className="row">
        {settings.map((setting, index) => (
          <div className="col-md-3" key={index}>
            <div className="form-group">
              <label>{setting.label}</label>
              <select
                className="form-control"
                value={form[setting.field] ? 'Yes' : 'No'} // Directly using the boolean value from formMaster
                onChange={(e) => onFormChange(setting.field, e.target.value === 'Yes')}
                disabled={shouldDisableFields} 
              >
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
          </div>
        ))}
      </div>
    );
  };
  
  export default FormMasterSettings;
  